module.exports = __webpack_public_path__ + "fonts/Monotype  - Neue Plak Condensed Black.2d9691d.ttf";